import { useMemo } from 'react';

import type { Address } from './ContactTypes';
import { getAddressesFromContacts } from './AddressesSourceService';
import { useContacts } from './useContacts';

interface AddressesState {
    isLoading: boolean;
    hasError: boolean;
    addresses: Address[];
}

export const useAddresses = (): [AddressesState, () => void] => {
    const { allEntities: contacts, isPending, error, refetch } = useContacts();
    const addresses = useMemo(() => getAddressesFromContacts(contacts), [contacts]);

    return [
        {
            isLoading: isPending,
            hasError: !!error,
            addresses,
        },
        refetch,
    ];
};
